import React, { useState, useEffect } from 'react';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import ProfileInformation from '../Profile/ProfileInformation';
import AddressInformation from '../Profile/AddressInformation';
import AvnetContactInformation from '../Profile/AvnetContactInformation';
import liveAuth from 'src/helper/liveAuth';
import ShowAlert from 'src/component/Global/ShowAlert';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const Profile = () => {
    const c = System.getParams().tab;
    const { ProfileTab: { ProfileInfo, AddressBook, Contact }} = Constants
    const { storageName: { ACCOUNT_LINK_SUCCESS_MESSAGE }} = System
    const [activeTab, setActiveTab] = useState(c ? c : ProfileInfo)
    const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
    const { translation:t } = System;

    const onChangeTab = (tab) => {
        setActiveTab(tab)
        let newUrl = '?tab=' + tab;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }

    useEffect(() => {
        if (sessionStorage.getItem(ACCOUNT_LINK_SUCCESS_MESSAGE)) {
            system_alert_indicator({
                name: 'profile',
                message: t('thankYouForRegistrationMessage'),
                type: "success"
            })
            sessionStorage.removeItem(ACCOUNT_LINK_SUCCESS_MESSAGE)
        } else {
            clear_all_system_alert()
        }
    }, [activeTab])

    return (
        <>
            <div className='container profile-container mb-5'>
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">{t('profile')}</div>
                {liveAuth.check() &&
                    <>
                        <div className="bs5 row mt-2">
                            <div className='col-12'>
                            <ShowAlert onlyShowMessage={['profile']} />
                            </div>
                        </div>

                        <div className='profile-tabs'>
                            <ul className="bs5 nav nav-tabs">
                                <li>
                                    <a className={"text-uppercase font-bold " + (activeTab === ProfileInfo ? 'active' : '')}
                                        onClick={() => onChangeTab(ProfileInfo)}><span className="text-uppercase">{t('accountInformation')}</span></a>
                                </li>
                                <li>
                                    <a className={"text-uppercase font-bold " + (activeTab === AddressBook ? 'active' : '')}
                                        onClick={() => onChangeTab(AddressBook)}><span>{t('addressBook')}</span></a>
                                </li>
                                <li>
                                    <a className={"text-uppercase font-bold " + (activeTab === Contact ? 'active' : '')}
                                        onClick={() => onChangeTab(Contact)}><span className="text-uppercase">{t('myAvnetContacts')}</span></a>
                                </li>
                            </ul>
                        </div>
                        {activeTab === ProfileInfo ?
                            <div className='profile-tabs-content'>
                                <ProfileInformation />
                            </div> :
                            activeTab === AddressBook ?
                                <div className='profile-tabs-content'>
                                    <AddressInformation />
                                </div> :
                                <div className='profile-tabs-content'>
                                    <AvnetContactInformation />
                                </div>
                        }
                    </>
                }
            </div>

        </>
    );
}

export default Profile;